import { SALESFORCE_LOCALES } from './constants.js';

const isValidISOLocale = (locale) => /^([a-z]{2})(?:[-_]?([A-Z]{2}))?$/.test(locale);
const getBaseLanguage = (locale) => locale.substring(0, 2).toLowerCase();
const findValidLocale = (locale) => Object.keys(SALESFORCE_LOCALES).includes(locale)
    ? SALESFORCE_LOCALES[locale]
    : undefined;
const getSalesforceLanguage = (locale) => {
    var _a;
    if (!isValidISOLocale(locale)) {
        return SALESFORCE_LOCALES.en_GB;
    }
    const salesforceLocale = (_a = findValidLocale(locale)) !== null && _a !== void 0 ? _a : findValidLocale(getBaseLanguage(locale));
    return salesforceLocale !== null && salesforceLocale !== void 0 ? salesforceLocale : SALESFORCE_LOCALES.en_GB;
};

export { getSalesforceLanguage };
//# sourceMappingURL=getSalesforceLanguage.js.map
